module.exports = __webpack_public_path__ + "img/logo-new.87b29215.png";